
export const HapticFeedback = () => {
    const hapticEnabled = localStorage.getItem("HapticFeedback");
    const isHapticEnabled = hapticEnabled === null || hapticEnabled === "true";

    if (window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback && isHapticEnabled) {
        window.Telegram.WebApp.HapticFeedback.impactOccurred('medium');
    }
};
